import React, { useEffect, useRef, useState } from "react";
import "./HomeComponent.scss";
import { Link } from "react-router-dom";
import InstagramPlug from "../Common/InstagramPlug";

const HomeComponent = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 700);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 700);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return <div className="home-container">
        <div className="splash-image-container">
            <div className="splash-image"></div>
        </div>
        <div className="center-card">
            <div className="column details-column">
                {/* <img className="home-title" src={logo} alt=""/> */}
                <h1 className="home-title">Pidgietatts</h1>
                {isMobile && (
                    <div className="mobile booking-container" style={{ margin: '1.5rem 0' }}>
                        <Link to={"/contact"} className="button">Book an Appointment</Link>
                    </div>
                )}
                <div className="bio">
                    <div className="bio-column-left">
                        <h3>About Me</h3>
                        <p>Hi I'm Addie! <span style={{fontStyle: "italic"}}>(She/They)</span><br/>
                        I'm a licensed tattoo artist working in Vancouver, WA. I prefer working in a colorful cartoony/illustrative style with bold lines but I also love to experiment with different styles. Subjects I'm interested in tattooing:</p>
                        <ul>
                            <li>video games</li>
                            <li>insects</li>
                            <li>cute critters</li>
                            <li>botanicals</li>
                            <li>knights, wizards, dragons</li>
                            <li>cartoons</li>
                        </ul>
                        <p>When I'm not tattooing I'm usually at home playing video games with my husband and two kitties, outside enjoying the PNW views, or searching for the best boba in the city.</p>
                    </div>
                    <div className="bio-column-right">
                        <img src={require("../assets/img/bio/BIOPIC-3.jpg")} alt="pic 3" />
                        <img src={require("../assets/img/bio/BIOPIC-2.jpg")} alt="pic 2" />
                        <img src={require("../assets/img/bio/BIOPIC-4.jpg")} alt="pic 4" />
                        <img src={require("../assets/img/bio/BIOPIC-5.jpg")} alt="pic 5" />
                        <img src={require("../assets/img/bio/BIOPIC-1.jpg")} alt="pic 1" />
                    </div>
                </div>
            </div>
            <div className="column">
                {!isMobile && (
                    <div className="booking-container">
                        <Link to={"/contact"} className="button">Book an Appointment</Link>
                    </div>
                )}
                <div className="works-preview">
                    <InstagramPlug/>
                </div>
            </div>
        </div>
    </div>
}

export default HomeComponent;